import {
  Badge,
  Box,
  Center,
  Divider,
  Flex,
  HStack,
  IconButton,
  Stack,
} from "@chakra-ui/react";
import appConfig from "../app-config";
import { Logo } from "../components/shared/Logo";
import { MaterialIcon } from "../components/shared/MaterialIcon";
import { UserSmudge } from "../components/shared/UserSmudge";
import { useAuth } from "../providers/AuthProvider";
import { NavItem } from "./NavItem";
import { useToggleSidebarOpen } from "./store/actions/useToggleSidebarOpen";
import { useSelectIsSidebarOpen } from "./store/select/useSelectIsSidebarOpen";

const AppSidebarStyles = {
  px: {
    px: 4,
  },
  py: {
    py: 6,
  },
};

export const AppSidebar = () => {
  const { userProfile } = useAuth();

  const toggleSidebarOpen = useToggleSidebarOpen();
  const isSidebarOpen = useSelectIsSidebarOpen();

  const isEnableEncrypt = appConfig.Settings.isEnableEncrypt;

  return (
    <Box
      id="app-sidenav"
      bg={userProfile?.is_admin ? "sidebar.bg.admin" : "sidebar.bg"}
      color="sidebar.text"
      fontSize={"md"}
      w="80"
      minW="80"
      transition={"margin-left 250ms ease-out,transform 250ms ease-out"}
      ml={isSidebarOpen ? "0" : "-80"}
      borderRightWidth={"1px"}
      borderRightColor={"sidebar.border"}
    >
      <Flex h="full" direction="column">
        <HStack
          alignItems="center"
          {...AppSidebarStyles["py"]}
          {...AppSidebarStyles["px"]}
        >
          <Box position={"absolute"}>
            <IconButton
              variant={"ghost"}
              _hover={{
                color: "gray.200",
                bg: "sidebar.bg.active",
              }}
              onClick={toggleSidebarOpen}
              icon={<MaterialIcon name="menu_open" variant="outline" />}
              aria-label="close menu"
            ></IconButton>
          </Box>
          <Center flex={1}>
            <Logo.White h={{ base: "1.5rem" }} />
          </Center>
        </HStack>

        <Stack
          pt={8}
          spacing="8"
          flex="1"
          overflow="auto"
          {...AppSidebarStyles["py"]}
          {...AppSidebarStyles["px"]}
        >
          <Stack spacing="1" as="nav">
            <NavItem iconName="apps" label="Registries" to="/app/registries" />
            <NavItem iconName="join_inner" label="Cohorts" to="/app/cohorts" />
            {isEnableEncrypt && (
              <NavItem
                iconName="enhanced_encryption"
                label="Encrypt"
                to="/app/encrypt"
                endElement={<Badge colorScheme={"cyan"}>Beta</Badge>}
              />
            )} 
            //We could use "partner_exchange" too 
            <NavItem iconName="compare_arrows" label="Exchange" to="/app/exchange" />
            {/* <NavItem
              iconName="analytics"
              label="Analyze"
              to="/app/soon"
              endElement={<Badge colorScheme={"cyan"}>Soon</Badge>}
            /> */}
            {/* <NavItem
              iconName="workspaces"
              label="Team"
              to="/app/soon"
              endElement={<Badge colorScheme={"cyan"}>Soon</Badge>}
            />
            <NavItem
              iconName="group_work"
              label="Acquire"
              to="/app/soon"
              endElement={<Badge colorScheme={"cyan"}>Soon</Badge>}
            />
            <NavItem
              iconName="local_library"
              label="Share"
              to="/app/soon"
              endElement={<Badge colorScheme={"cyan"}>Soon</Badge>}
            /> */}
          </Stack>
          {/* <SidebarGroup label="Favorites">
            <NavItem
              to="/app/registries/b83504a4-abd0-4bba-9c95-c216fe6e4fdc"
              iconName="star_outline"
              label="Xia-Gibbs"
            />
            <NavItem
              to="/app/registries/921bceaf-f6a6-43a3-8175-66659f364971"
              iconName="star_outline"
              label="Xanthan-Gum"
            />
          </SidebarGroup> */}
        </Stack>

        <Stack
          spacing={4}
          {...AppSidebarStyles["py"]}
          {...AppSidebarStyles["px"]}
        >
          <Stack spacing="1">
            <NavItem
              to="/app/settings/profile"
              iconName="settings"
              label="Profile"
            />
            <NavItem
              to="/app/settings/support"
              iconName="support"
              label="Support"
            />
            {/* <NavItem
              to="/app/support"
              iconName="support"
              label="Help and Support"
              endElement={<Circle size="2" bg="blue.400" />}
            /> */}
          </Stack>
        </Stack>

        <Divider></Divider>

        <Stack {...AppSidebarStyles["py"]} {...AppSidebarStyles["px"]} py={"6"}>
          <UserSmudge
            name={`${userProfile?.first_name} ${userProfile?.last_name}`}
            email={userProfile?.email}
          ></UserSmudge>
        </Stack>
      </Flex>
    </Box>
  );
};

export default AppSidebar;
